import {
  FilterItem,
  ConfigurationMode,
} from './stream-category-config.reducer';
import actionCreatorFactory from 'typescript-fsa';
import { Dictionary } from 'ramda';
const actionCreator = actionCreatorFactory('StreamCategoryConfig');

export interface StreamCategory {
  categoryId: number;
  appId: number;
}

export const setStreamConfigCategory = actionCreator<StreamCategory>(
  'CATEGORY_SET'
);

export const selectStreamConfigCategory = actionCreator<StreamCategory>(
  'CATEGORY_SELECT'
);

export const resetStreamConfig = actionCreator('RESET');

export const updateStreamConfigFilterItems = actionCreator<{
  filterId: string;
  filterItems: FilterItem[] | Dictionary<FilterItem>;
}>('FILTER_ITEMS_UPDATE');

export const updateStreamConfigFilters = actionCreator<{
  availableFilters: {
    [key: string]: FilterItem[];
  };
}>('FILTERS_UPDATE');

export const setUpdateFilterItemsComplete = actionCreator(
  'FILTERS_UPDATE_COMPLETE'
);

export const updateStreamConfigFilterNames = actionCreator<{
  filterNames: {
    [key: string]: string;
  };
}>('FILTER_NAMES_UPDATE');

export const addStreamConfigActiveFilterItem = actionCreator<{
  filterItem: FilterItem;
}>('ACTIVE_ITEM_ADD');

export const addStreamConfigActiveFilterItems = actionCreator<{
  filterItems: FilterItem[];
}>('ACTIVE_ITEMS_ADD');

export const removeStreamConfigActiveFilterItem = actionCreator<{
  filterItem: FilterItem;
}>('ACTIVE_ITEM_REMOVE');

export const updateStreamConfigActiveFilterItems = actionCreator<{
  filterItems: FilterItem[];
}>('ACTIVE_ITEMS_UPDATE');

export const updateStreamConfigProductCount = actionCreator<{
  productCount: number;
}>('PRODUCT_COUNT_UPDATE');

export const setStreamConfigLoading = actionCreator<{
  loading: boolean;
}>('LOADING_SET');

export const setStreamConfigMode = actionCreator<{
  mode: ConfigurationMode;
}>('MODE_SET');

export const toggleBlacklistForFilter = actionCreator<{
  filterId: string;
}>('TOGGLE_BLACKLIST');

export const toggleIsInheritedByChildCategories = actionCreator(
  'TOGGLE_IS_INHERITED_BY_CHILDREN'
);



// WEBPACK FOOTER //
// ./src/store/StreamCategoryConfig/stream-category-config.actions.ts